module.exports = __webpack_public_path__ + "static/media/hotel_checkin_icon.fc712fdd.svg";